import { DestroyRef } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { BsDatepickerConfig, BsLocaleService } from "ngx-bootstrap/datepicker";

// Week numbers ("plan it in week 38") are everyday planning language in the Netherlands but read as
// noise elsewhere, where users mistake the column for dates (SUP-5018). Show them for Dutch only.
const WEEK_NUMBER_LOCALES = ["nl"];

export function showWeekNumbersForLocale(locale: string): boolean {
  return WEEK_NUMBER_LOCALES.includes(locale?.substring(0, 2));
}

// Keeps the root datepicker defaults in step with the active locale. A picker's own [bsConfig] is merged
// over these defaults, so component configs must not set showWeekNumbers themselves - in particular they
// must not start from `new BsDatepickerConfig()`, which carries the library default of `true`.
export function syncDatepickerWeekNumbers(localeService: BsLocaleService, rootConfigs: BsDatepickerConfig[], destroyRef: DestroyRef): void {
  localeService.localeChange.pipe(takeUntilDestroyed(destroyRef)).subscribe((locale) => {
    const show = showWeekNumbersForLocale(locale);
    for (const config of rootConfigs) {
      config.showWeekNumbers = show;
    }
  });
}
